"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Grid = _interopRequireDefault(require("../Grid"));
var _isDsElement = _interopRequireDefault(require("../utilities/isDsElement"));
var _layout = require("./layout.styles");
const _excluded = ["children", "component", "className", "bgColor", "gutters", "columnSpacing", "yMargin", "gap"];
/**
 * **❗️ DEPRECATED**: Use the new `ContentBlock` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/layout-contentblock-contentblock):
 *
 * ```tsx
 * import { ContentBlock } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/layout-contentblock-contentblock)
 *
 * @deprecated
 */
const Layout = _ref => {
  let {
      children,
      component = 'div',
      className,
      bgColor,
      gutters,
      columnSpacing = 1,
      yMargin = {
        xs: 6,
        xl: 10
      },
      gap = {
        xl: 8
      }
    } = _ref,
    containerHtmlAttributes = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  if (!_react.default.Children.toArray(children).length) return null;
  let withColumns = false;
  _react.default.Children.forEach(children, child => {
    if ((0, _isDsElement.default)(child, ['LayoutColumn'])) {
      withColumns = true;
    }
  });
  const {
    cx,
    classes
  } = (0, _layout.useLayoutStyles)({
    bgColor,
    columnSpacing,
    gutters,
    gap,
    withColumns,
    yMargin
  });
  const Wrapper = withColumns ? _Grid.default : component;
  const wrapperProps = withColumns ? {
    container: true,
    component: component
  } : {};
  return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({}, wrapperProps, containerHtmlAttributes, {
    className: cx(classes.root, {
      [classes.withColumns]: withColumns
    }, classes.responsiveVerticalMargin, classes.responsiveGap, classes.outerSpacing, className)
  }), children);
};
var _default = exports.default = Layout;